import { useCallback, useEffect, useState } from "react";
import JornadaTrabalhadaService from "../../services/resource/jornadaTrabalhadaService";
import { toast } from "react-toastify";
import { renderMultiSelect } from "../bp/BPRelatorio";
import FuncionarioService from "../../services/resource/funcionarioService";
import FilialService from "../../services/resource/filialService";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column";
import JornadaFuncionarioList from "./JornadaFuncionarioList";
import { useNavigate } from "react-router-dom";

function RelatorioJornadaTrabalhada() {
    const jornadaTrabalhadaService = new JornadaTrabalhadaService();
    const funcionarioService = new FuncionarioService();
    const filialService = new FilialService();
    const navigate = useNavigate();
    
    const [loading, setLoading] = useState(false);

    const [consolidado, setConsolidado] = useState({
        totalFuncionarios: 0,
        totalFiliais: 0,
        totalCargos: 0,
        totalFaltas: 0,
        horasTrabalhadas: 0,
        horasPrevistas: 0,
        saldoHoras: 0,
        saldoBancoHoras: 0,
        horasExtras50: 0,
        horasExtras60: 0,
        horasExtras80: 0,
        horasExtras100: 0,
        horasExtrasTotais: 0,
    });

    const [objetosFiltrados, setObjetosFiltrados] = useState({
        filial: [],
        cargo: [],
        funcionario: [],
    });
    const [filtroFalta, setFiltroFalta] = useState("");
    const [filtroHoraExtra, setFiltroHoraExtra] = useState("");
    const [modalLista, setModalLista] = useState(false);
    const [modalFuncionario, setModalFuncionario] = useState(false);
    const [funcionario, setFuncionario] = useState(false);
    const [jornadas, setJornadas] = useState([]);
    const [faltas, setFaltas] = useState([]);
    const [horasExtras, setHorasExtras] = useState([]);

    const [listaSelecionada, setListaSelecionada] = useState({
        titulo: "",
        itens: []
    });

    const [filtros, setFiltros] = useState({
        filial: [],
        cargo: [],
        funcionario: [],
    });

    const [selectedFilters, setSelectedFilters] = useState({
        dataInicial: "",
        dataFinal: "",

        filial: [],
        cargo: [],
        funcionario: [],
    });

    const carregarConsolidado = useCallback(async () => {

        if (!selectedFilters.dataInicial || !selectedFilters.dataFinal) {
            return;
        }

        try {

            setLoading(true);

            const response = await jornadaTrabalhadaService.relatorioConsolidado(selectedFilters);

            setConsolidado(response.data);

        } catch (error) {

            console.error(error);

            toast.error(
                error?.response?.data?.message ||
                "Erro ao carregar relatório consolidado"
            );

        } finally {

            setLoading(false);
        }



        listarFaltas();
        listarFiltros();
        listarHorasExtras();

    }, [selectedFilters]);

    const listarFiltros = () => {
        jornadaTrabalhadaService.filtros(selectedFilters).then(res => {
            setObjetosFiltrados({
                filial: res.data.filiais.map(f => ({
                    value: f.value,
                    label: f.label
                })),
                cargo: res.data.cargos.map(c => ({
                    value: c,
                    label: c
                })),
                funcionario: res.data.funcionarios.map(f => ({
                    value: f.value,
                    label: f.label
                }))
            });

        });
    }

    const listarFaltas = () => {
        jornadaTrabalhadaService.listarFaltas(selectedFilters).then(res => {
            setFaltas(res.data)
        })
    }

    const listarHorasExtras = () => {
        jornadaTrabalhadaService.listarHorasExtras(selectedFilters).then(res => {
            setHorasExtras(res.data)
        })
    }

    const alterarFiltro = (campo, valor) => {

        setSelectedFilters(prev => ({
            ...prev,
            [campo]: valor
        }));
    };

    const pesquisar = () => {
        carregarConsolidado();
    };

    const handleChange = (key, value) => {
        setSelectedFilters(prev => ({
            ...prev,
            [key]: value
        }));
    };

    useEffect(() => {

        const hoje = new Date();

        const primeiroDia = new Date(
            hoje.getFullYear(),
            hoje.getMonth(),
            1
        );

        setSelectedFilters({
            dataInicial: primeiroDia.toISOString().split("T")[0],
            dataFinal: hoje.toISOString().split("T")[0],

            filial: [],
            cargo: [],
            funcionarioId: [],
        });

    }, []);

    useEffect(() => {
        carregarConsolidado();
    }, []);

    useEffect(() => {

        Promise.all([
            funcionarioService.listarCargos(),
            filialService.listar()
        ])
            .then(([cargosResponse, filiaisResponse]) => {

                setFiltros(prev => ({
                    ...prev,
                    cargo: cargosResponse.data,
                    filial: filiaisResponse.data?.map(f => ({
                        value: f.id,
                        label: f.label || f.nome
                    }))
                }));

            })
            .catch(error => {
                console.error(error);
            });

    }, []);

    useEffect(() => {
        funcionarioService.listaFuncionarios({ filiais: selectedFilters.filial, somenteComPonto: true }).then(res => {
            setFiltros(prev => ({
                ...prev,
                funcionario: res.data?.map(f => ({
                    value: f.id,
                    label: f.label || f.nome
                }))
            }))
        })
    }, [selectedFilters.filial]);

    const exportarExcel = async () => {

        try {

            const response = await jornadaTrabalhadaService.exportarExcel(selectedFilters);

            const url = window.URL.createObjectURL(response.data);

            const link = document.createElement("a");

            link.href = url;
            link.download = `jornada.xlsx`;

            document.body.appendChild(link);

            link.click();

            link.remove();

            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error(error);
        }
    };

    const abrirLista = (tipo, titulo, itens) => {

        setListaSelecionada({
            tipo,
            titulo,
            itens
        });

        setModalLista(true);
    };

    const minutosParaHoras = (minutos = 0) => {

        const horas = Math.floor(minutos / 60);
        const mins = minutos % 60;

        return `${horas}h ${mins}min`;
    };

    const percentualPresenca = () => {

        if (!consolidado.horasPrevistas) {
            return 0;
        }

        return (
            (consolidado.horasTrabalhadas /
                consolidado.horasPrevistas) *
            100
        ).toFixed(2);
    };

    const saldoFormatado = () => {

        return minutosParaHoras(
            consolidado.saldoBancoHoras
        );
    };

    const kpis = [
        {
            title: "Funcionários",
            value: consolidado.totalFuncionarios,
            icon: "👥",
            color: "bg-indigo-500",
            onClick: () =>
                abrirLista(
                    "funcionario",
                    "Funcionários",
                    objetosFiltrados.funcionario
                )
        },
        {
            title: "Filiais",
            value: consolidado.totalFiliais,
            icon: "🏢",
            color: "bg-sky-500",
            onClick: () =>
                abrirLista(
                    "filial",
                    "Filiais",
                    objetosFiltrados.filial
                )
        },
        {
            title: "Cargos",
            value: consolidado.totalCargos,
            icon: "🪪",
            color: "bg-violet-500",
            onClick: () =>
                abrirLista(
                    "cargo",
                    "Cargos",
                    objetosFiltrados.cargo
                )
        },
        {
            title: "Faltas",
            value: consolidado.totalFaltas,
            icon: "📅",
            color: "bg-red-500",
        },
        {
            title: "Presença",
            value: `${percentualPresenca()}%`,
            icon: "✅",
            color: "bg-emerald-500",
            badge: (
                <span
                    className={`text-[10px] font-semibold px-2 py-0.5 rounded-full
                ${percentualPresenca() >= 90
                            ? "bg-emerald-50 text-emerald-600"
                            : percentualPresenca() >= 75
                                ? "bg-amber-50 text-amber-600"
                                : "bg-red-50 text-red-500"
                        }`}
                >
                    {percentualPresenca()}%
                </span>
            ),
        },
        {
            title: "Banco de Horas",
            value: saldoFormatado(),
            icon: "🏦",
            color: consolidado.saldoBancoHoras >= 0
                ? "bg-sky-500"
                : "bg-red-500",
            valueClassName: consolidado.saldoBancoHoras >= 0
                ? "text-sky-600"
                : "text-red-500",
        }
    ];

    const adicionarFiltro = (tipo, item) => {

        const valor = item.id ?? item.value;

        const jaExiste = selectedFilters[tipo]?.includes(valor);

        if (jaExiste) {
            return;
        }

        setSelectedFilters(prev => ({
            ...prev,
            [tipo]: [...(prev[tipo] || []), valor]
        }));
    };

    const abrirModalDetalhesFuncionario = (data) => {
        setFuncionario(data)
        setModalFuncionario(true);
    }

    const capitalize = (texto = "") =>
        texto
            .toLowerCase()
            .split(" ")
            .map(p => p.charAt(0).toUpperCase() + p.slice(1))
            .join(" ");

    return (
        <div className="min-h-screen bg-background font-sans text-foreground">

            {/* ── Topbar ─────────────────────────────────────────────────────── */}
            <header className="sticky top-0 z-50 bg-card border-b border-border shadow-xs">
                <div className="flex items-center justify-between px-6 h-14">

                    {/* Logo + título */}
                    <div className="flex items-center gap-3.5">
                        <div className="font-display w-8 h-8 bg-primary rounded-lg flex items-center justify-center text-primary-foreground text-xs font-extrabold tracking-tight shrink-0">
                            JT
                        </div>
                        <div>
                            <p className="text-sm font-bold text-foreground leading-tight">Jornada Trabalhada</p>
                            <p className="text-[11px] text-muted-foreground">Relatório consolidado de horas</p>
                        </div>
                    </div>

                    {/* Ação de pesquisa */}
                    <div className="flex items-center gap-2">
                        <button
                            onClick={() => navigate("/jornada-trabalhada/horas-extras")}
                            disabled={loading}
                            className="flex items-center gap-2 px-4 py-2 bg-muted hover:bg-muted/70 disabled:opacity-50 text-foreground text-xs font-semibold rounded-xl shadow-xs transition-colors duration-150"
                        >
                            <i className="fa fa-external-link-square" />
                            Abrir Acompanhamento de Folha
                        </button>
                        <button
                            onClick={pesquisar}
                            disabled={loading}
                            className="flex items-center gap-2 px-4 py-2 bg-primary hover:brightness-95 disabled:opacity-50 text-primary-foreground text-xs font-semibold rounded-xl shadow-xs transition-all duration-150"
                        >
                            <i className={loading ? "fa fa-spinner fa-spin" : "fa fa-search"} />
                            {loading ? "Carregando…" : "Pesquisar"}
                        </button>

                    </div>
                </div>
            </header>

            <main className="px-5 py-5 space-y-4 max-w-screen-2xl mx-auto">

                {/* ── selectedFilters ──────────────────────────────────────────────────── */}
                <div className="bg-card border border-border rounded-2xl px-5 py-4 shadow-card">
                    <div className="flex flex-wrap items-end gap-3">

                        <DateFilter
                            label="Data Inicial"
                            value={selectedFilters.dataInicial}
                            onChange={(value) => alterarFiltro("dataInicial", value)}
                        />

                        <DateFilter
                            label="Data Final"
                            value={selectedFilters.dataFinal}
                            onChange={(value) => alterarFiltro("dataFinal", value)}
                        />

                        {/* Divisor vertical */}
                        <div className="hidden sm:block w-px h-9 bg-border self-end mb-2" />

                        <div className="flex flex-col gap-1 w-1/3">
                            {renderMultiSelect("Filial", "filial", filtros.filial, "", selectedFilters, handleChange, false)}
                        </div>

                        <div className="flex flex-col gap-1 w-1/4">
                            {renderMultiSelect("Cargo", "cargo", filtros.cargo, "", selectedFilters, handleChange, false)}
                        </div>

                        <div className="flex flex-col gap-1 w-1/3">
                            {renderMultiSelect("Funcionário", "funcionario", filtros.funcionario, "", selectedFilters, handleChange, false)}
                        </div>

                        <button
                            onClick={pesquisar}
                            disabled={loading}
                            className="self-end flex items-center mb-2 gap-2 h-9 px-4 bg-primary hover:brightness-95 disabled:opacity-50 text-primary-foreground text-xs font-semibold rounded-xl shadow-card transition-all duration-150"
                        >
                            <i className={loading ? "fa fa-spinner fa-spin" : "fa fa-search"} />
                            Pesquisar
                        </button>

                        <button
                            onClick={exportarExcel}
                            className="self-end flex items-center mb-2 gap-2 h-9 px-4 bg-success hover:brightness-95 disabled:opacity-50 text-success-foreground text-xs font-semibold rounded-xl shadow-card transition-all duration-150"
                        >
                            <i className="fa fa-file-excel mr-2" />
                            Exportar Excel
                        </button>

                        {selectedFilters.funcionario?.length === 1 &&
                            <button
                                onClick={() => { abrirModalDetalhesFuncionario(selectedFilters.funcionario[0]) }}
                                className="self-end flex items-center mb-2 gap-2 h-9 px-4 bg-muted hover:bg-muted/70 disabled:opacity-50 text-foreground text-xs font-semibold rounded-xl shadow-card transition-colors duration-150"
                            >
                                <i className="fa fa-info-circle mr-2" />
                                Ver Detalhamento do Usuário
                            </button>
                        }

                    </div>
                </div>

                {consolidado.totalFuncionarios === 0 ?
                    <div className="bg-card border border-border rounded-2xl p-12 text-center shadow-card">
                        <p className="text-3xl mb-2">📭</p>
                        <p className="text-sm font-semibold text-muted-foreground">Nenhuma informação encontrada</p>
                        <p className="text-xs text-muted-foreground mt-1">Ajuste os filtros e pesquise novamente.</p>
                    </div>

                    :
                    <>

                        {/* ── KPIs — Visão Geral ────────────────────────────────────────── */}
                        <div className="flex items-center gap-3">
                            <span className="text-[10px] font-bold uppercase tracking-widest text-muted-foreground">Visão Geral</span>
                            <div className="flex-1 h-px bg-border" />
                        </div>
                        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
                            {kpis.map((kpi) => (
                                <KPICard
                                    key={kpi.title}
                                    {...kpi}
                                    loading={loading}
                                />
                            ))}
                        </div>

                        {/* ── KPIs — Horas ─────────────────────────────────────────────── */}
                        <div className="flex items-center gap-3">
                            <span className="text-[10px] font-bold uppercase tracking-widest text-muted-foreground">Horas</span>
                            <div className="flex-1 h-px bg-border" />
                        </div>

                        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-3">

                            {/* Horas Trabalhadas */}
                            <div className="bg-card border border-border rounded-2xl p-5 shadow-card relative overflow-hidden">
                                <div className="absolute top-0 left-0 right-0 h-0.5 rounded-t-2xl bg-emerald-500" />
                                <p className="text-xl mb-2">⏱️</p>
                                {loading
                                    ? <div className="h-8 w-3/4 bg-muted animate-pulse rounded-lg" />
                                    : <p className="text-2xl font-bold text-foreground leading-none">{minutosParaHoras(consolidado.horasTrabalhadas)}</p>
                                }
                                <p className="text-[10px] font-bold uppercase tracking-widest text-muted-foreground mt-1">Horas Trabalhadas</p>
                                {!loading && (
                                    <p className="text-xs text-muted-foreground mt-1">
                                        Previsto <strong className="text-foreground">{minutosParaHoras(consolidado.horasPrevistas)}</strong>
                                    </p>
                                )}
                            </div>

                            {/* Saldo de Horas */}
                            <div className="bg-card border border-border rounded-2xl p-5 shadow-card relative overflow-hidden">
                                <div className={`absolute top-0 left-0 right-0 h-0.5 rounded-t-2xl ${consolidado.saldoHoras >= 0 ? "bg-sky-500" : "bg-red-500"}`} />
                                <p className="text-xl mb-2">⚖️</p>
                                {loading
                                    ? <div className="h-8 w-3/4 bg-muted animate-pulse rounded-lg" />
                                    : <p className={`text-2xl font-bold leading-none ${consolidado.saldoHoras >= 0 ? "text-sky-600" : "text-red-500"}`}>
                                        {minutosParaHoras(Math.abs(consolidado.saldoHoras))}
                                    </p>
                                }
                                <p className="text-[10px] font-bold uppercase tracking-widest text-muted-foreground mt-1">Saldo de Horas</p>
                                {!loading && (
                                    <p className="text-xs mt-1">
                                        <span className={`font-semibold ${consolidado.saldoHoras >= 0 ? "text-emerald-500" : "text-red-500"}`}>
                                            {consolidado.saldoHoras >= 0 ? "▲ positivo" : "▼ negativo"}
                                        </span>
                                    </p>
                                )}
                            </div>

                            {/* Total de Extras */}
                            <div className="bg-card border border-border rounded-2xl p-5 shadow-card relative overflow-hidden">
                                <div className="absolute top-0 left-0 right-0 h-0.5 rounded-t-2xl bg-amber-500" />
                                <p className="text-xl mb-2">⚡</p>
                                {loading
                                    ? <div className="h-8 w-3/4 bg-muted animate-pulse rounded-lg" />
                                    : <p className="text-2xl font-bold text-foreground leading-none">{minutosParaHoras(consolidado.horasExtrasTotais)}</p>
                                }
                                <p className="text-[10px] font-bold uppercase tracking-widest text-muted-foreground mt-1">Total de Extras</p>
                            </div>

                            {/* Detalhamento extras — mini grid interno */}
                            <div className="bg-card border border-border rounded-2xl p-5 shadow-card relative overflow-hidden">
                                <div className="absolute top-0 left-0 right-0 h-0.5 rounded-t-2xl bg-orange-400" />
                                <p className="text-[10px] font-bold uppercase tracking-widest text-muted-foreground mb-3">Detalhamento Extras</p>
                                {loading ? (
                                    <div className="space-y-2">
                                        {[...Array(4)].map((_, i) => (
                                            <div key={i} className="h-4 bg-muted animate-pulse rounded" />
                                        ))}
                                    </div>
                                ) : (
                                    <div className="space-y-1.5">
                                        {[
                                            { label: "50%", value: consolidado.horasExtras50, color: "text-amber-500" },
                                            { label: "60%", value: consolidado.horasExtras60, color: "text-orange-500" },
                                            { label: "80%", value: consolidado.horasExtras80, color: "text-orange-600" },
                                            { label: "100%", value: consolidado.horasExtras100, color: "text-red-500" },
                                        ].map(({ label, value, color }) => (
                                            <div key={label} className="flex items-center justify-between">
                                                <span className="text-xs text-muted-foreground">HE {label}</span>
                                                <span className={`text-xs font-bold ${color}`}>
                                                    {minutosParaHoras(value)}
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* ── Barra de progresso presença ──────────────────────────────── */}
                        {!loading && consolidado.horasPrevistas > 0 && (
                            <div className="bg-card border border-border rounded-2xl px-5 py-4 shadow-card">
                                <div className="flex items-center justify-between mb-2">
                                    <span className="text-xs font-bold text-foreground">
                                        Aproveitamento de Horas
                                    </span>
                                    <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${percentualPresenca() >= 90
                                        ? "bg-emerald-50 text-emerald-600"
                                        : percentualPresenca() >= 75
                                            ? "bg-amber-50 text-amber-600"
                                            : "bg-red-50 text-red-500"
                                        }`}>
                                        {percentualPresenca()}%
                                    </span>
                                </div>

                                {/* track */}
                                <div className="h-2 bg-muted rounded-full overflow-hidden">
                                    <div
                                        className={`h-full rounded-full transition-all duration-700 ${percentualPresenca() >= 90
                                            ? "bg-emerald-500"
                                            : percentualPresenca() >= 75
                                                ? "bg-amber-400"
                                                : "bg-red-500"
                                            }`}
                                        style={{ width: `${Math.min(percentualPresenca(), 100)}%` }}
                                    />
                                </div>

                                <div className="flex justify-between mt-2">
                                    <span className="text-[10px] text-muted-foreground">
                                        Trabalhado <strong className="text-foreground">{minutosParaHoras(consolidado.horasTrabalhadas)}</strong>
                                    </span>
                                    <span className="text-[10px] text-muted-foreground">
                                        Previsto <strong className="text-foreground">{minutosParaHoras(consolidado.horasPrevistas)}</strong>
                                    </span>
                                </div>
                            </div>
                        )}

                        <div className="flex items-center gap-3">
                            <span className="text-[10px] font-bold uppercase tracking-widest text-muted-foreground">
                                Ocorrências
                            </span>
                            <div className="flex-1 h-px bg-border" />
                        </div>

                        <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">

                            {/* Faltas */}
                            <div className="bg-card border border-border rounded-2xl shadow-card overflow-hidden">

                                <div className="flex items-center justify-between px-4 py-3 border-b border-border">

                                    <div>
                                        <p className="text-[10px] font-bold uppercase tracking-widest text-muted-foreground">
                                            Faltas
                                        </p>

                                        <p className="text-xs text-muted-foreground">
                                            Registros encontrados
                                        </p>
                                    </div>

                                    <span className="px-2 py-1 rounded-full bg-red-50 text-red-600 text-xs font-semibold">
                                        {faltas.length}
                                    </span>

                                </div>

                                <div className="p-3 border-b border-border">

                                    <span className="p-input-icon-left w-full">
                                        <i className="pi pi-search" />
                                        <input
                                            type="text"
                                            value={filtroFalta}
                                            onChange={(e) => setFiltroFalta(e.target.value)}
                                            placeholder="Pesquisar funcionário, cargo ou filial..."
                                            className="w-full border border-border rounded-xl px-3 py-2 text-sm"
                                        />
                                    </span>

                                </div>

                                <DataTable
                                    value={faltas.filter(f =>
                                        JSON.stringify(f)
                                            .toLowerCase()
                                            .includes(filtroFalta.toLowerCase())
                                    )}
                                    paginator
                                    rows={5}
                                    size="small"
                                    stripedRows
                                    sortMode="multiple"
                                    rowClassName="text-xs cursor-pointer"
                                    paginatorClassName="text-xs cursor-pointer"
                                    responsiveLayout="scroll"
                                    emptyMessage="Nenhuma falta encontrada"
                                    onRowClick={(row) => abrirModalDetalhesFuncionario(row.data.funcionarioId)}
                                >

                                    <Column
                                        headerClassName="text-xs"
                                        header="Funcionário"
                                        sortable
                                        sortField="funcionarioNome"
                                        body={(row) => capitalize(row.funcionarioNome)}
                                    />

                                    <Column
                                        headerClassName="text-xs"
                                        field="funcionarioFilialNome"
                                        header="Filial"
                                        sortable
                                    />

                                    <Column
                                        headerClassName="text-xs"
                                        field="dataReferencia"
                                        header="Data"
                                        sortable
                                    />

                                    <Column
                                        headerClassName="text-xs"
                                        header="Ausência"
                                        body={(row) => (
                                            <span className="px-2 py-0.5 rounded-full bg-red-50 text-red-600 text-xs font-semibold">
                                                {minutosParaHoras(
                                                    row.horasPrevistas -
                                                    row.horasTrabalhadas
                                                )}
                                            </span>
                                        )}
                                    />

                                </DataTable>

                            </div>

                            {/* Horas Extras */}
                            <div className="bg-card border border-border rounded-2xl shadow-card overflow-hidden">

                                <div className="flex items-center justify-between px-4 py-3 border-b border-border">

                                    <div>
                                        <p className="text-[10px] font-bold uppercase tracking-widest text-muted-foreground">
                                            Horas Extras
                                        </p>

                                        <p className="text-xs text-muted-foreground">
                                            Maiores acumulados
                                        </p>
                                    </div>

                                    <span className="px-2 py-1 rounded-full bg-amber-50 text-amber-600 text-xs font-semibold">
                                        {horasExtras.length}
                                    </span>

                                </div>

                                <div className="p-3 border-b border-border">

                                    <input
                                        type="text"
                                        value={filtroHoraExtra}
                                        onChange={(e) => setFiltroHoraExtra(e.target.value)}
                                        placeholder="Pesquisar funcionário..."
                                        className="w-full border border-border rounded-xl px-3 py-2 text-sm"
                                    />

                                </div>

                                <DataTable
                                    value={horasExtras.filter(f =>
                                        JSON.stringify(f)
                                            .toLowerCase()
                                            .includes(filtroHoraExtra.toLowerCase())
                                    )}
                                    paginator
                                    rows={5}
                                    size="small"
                                    stripedRows
                                    sortMode="multiple"
                                    rowClassName="text-xs cursor-pointer"
                                    responsiveLayout="scroll"
                                    emptyMessage="Nenhuma hora extra encontrada"
                                    paginatorClassName="text-xs"
                                    onRowClick={(row) => abrirModalDetalhesFuncionario(row.data.funcionarioId)}
                                >


                                    <Column
                                        headerClassName="text-xs"
                                        header="Funcionário"
                                        sortable
                                        sortField="funcionarioNome"
                                        body={(row) => capitalize(row.funcionarioNome)}
                                    />

                                    <Column
                                        headerClassName="text-xs"
                                        field="funcionarioFilialNome"
                                        header="Filial"
                                        sortable
                                    />

                                    <Column
                                        headerClassName="text-xs"
                                        field="dataReferencia"
                                        header="Data"
                                        sortable
                                    />

                                    <Column
                                        headerClassName="text-xs"
                                        header="Horas Total"
                                        sortable
                                        sortField="horasExtrasTotais"
                                        body={(row) => (
                                            <span className="px-2 py-0.5 rounded-full bg-amber-50 text-amber-700 text-xs font-semibold">
                                                {minutosParaHoras(row.horasExtrasTotais)}
                                            </span>
                                        )}
                                    />

                                </DataTable>

                            </div>


                        </div>

                    </>
                }

            </main>

            <Dialog
                showHeader={false}

                contentClassName="rounded-lg p-0"
                blockScroll
                visible={modalFuncionario}
                onHide={() => setModalFuncionario(false)}
                className="w-[95%] h-[42vw]"
            >
                <JornadaFuncionarioList onClose={() => setModalFuncionario(false)} funcionarioId={funcionario} dataInicial={selectedFilters.dataInicial} dataFinal={selectedFilters.dataFinal} />
            </Dialog>

            <Dialog
                header={
                    <div className="flex items-center justify-between ">
                        <div>
                            <h2 className="text-xl font-bold text-foreground">
                                {listaSelecionada?.titulo}
                            </h2>

                            <p className="text-xs text-muted-foreground">
                                {listaSelecionada?.itens?.length} registros encontrados
                            </p>
                        </div>

                        <span className="px-3 py-1 rounded-full  bg-primary/10 text-primary text-xs font-semibold ">
                            {listaSelecionada.itens.length}
                        </span>

                    </div>
                }
                visible={modalLista}
                footer={null}
                onHide={() => setModalLista(false)}
                className="w-[90%]  h-100"
                blockScroll
            >

                <div className="space-y-4 pt-3">

                    {/* Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 gap-3 max-h-[65vh] overflow-auto pr-1">

                        {listaSelecionada.itens.map(item => {

                            const id = item.value;

                            const selecionado = selectedFilters[listaSelecionada.tipo]?.includes(id);

                            return (
                                <div
                                    key={id}
                                    className={`bg-card border rounded-2xl p-2 px-4 transition-all shadow-card  ${selecionado
                                        ? "border-emerald-300 bg-emerald-50"
                                        : "border-border hover:border-primary/40 hover:shadow-card"
                                        }`}
                                >

                                    <div className="flex justify-between items-center text-xs">
                                        <div>
                                            <div className="font-semibold text-foreground">
                                                <div className="font-semibold text-foreground">
                                                    {item.label}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="flex gap-2 text-[9px]">

                                            <button disabled={selecionado} onClick={() => adicionarFiltro(listaSelecionada.tipo, item)}
                                                className={`rounded-xl px-2 py-1 font-semibold transition-colors duration-150 ${selecionado ? "bg-muted text-muted-foreground cursor-not-allowed" : "bg-primary hover:brightness-95 text-primary-foreground"}`} >
                                                {selecionado ? "Já Adicionado no Filtro" : "Adicionar ao Filtro"}
                                            </button>
                                            {listaSelecionada.tipo === "funcionario" &&
                                                <button onClick={() => abrirModalDetalhesFuncionario(item.value)}
                                                    className={`rounded-xl px-2 py-1 font-semibold transition-colors duration-150 bg-muted hover:bg-muted/70 text-foreground cursor-pointer`} >
                                                    Ver Detalhes
                                                </button>
                                            }
                                        </div>
                                    </div>

                                </div>
                            );
                        })}

                    </div>

                </div>

            </Dialog>


        </div>
    );
}

export default RelatorioJornadaTrabalhada;

const DateFilter = ({
    label,
    value,
    onChange
}) => (
    <div className="flex flex-col mb-2">
        <label className="text-xs text-muted-foreground font-medium mb-1">
            {label}
        </label>

        <input
            type="date"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className="
                min-h-[38px]
                px-3 py-1.5
                border rounded-xl
                bg-card
                border-input
                hover:border-primary/55
                focus:border-primary
                focus:ring-2
                focus:ring-primary/15
                transition-colors duration-150
                w-full
            "
        />
    </div>
);

const KPICard = ({
    title,
    value,
    icon,
    color = "bg-indigo-500",
    loading = false,
    badge,
    valueClassName = "text-foreground",
    onClick
}) => {

    const clickable = typeof onClick === "function";

    return (
        <div
            onClick={onClick}
            className={`
                bg-card border border-border rounded-2xl p-4 shadow-card relative overflow-hidden
                ${clickable ? "cursor-pointer hover:shadow-soft hover:-translate-y-0.5 transition-all" : ""}
            `}
        >
            <div className={`absolute top-0 left-0 right-0 h-0.5 rounded-t-2xl ${color}`} />

            <div className="flex items-start justify-between">
                <p className="text-xl mb-1">{icon}</p>
                {badge}
            </div>

            {loading ? (
                <div className="h-7 w-3/4 bg-muted animate-pulse rounded-lg" />
            ) : (
                <p className={`text-2xl font-bold leading-none ${valueClassName}`}>
                    {value}
                </p>
            )}

            <p className="text-[10px] font-bold uppercase tracking-widest text-muted-foreground mt-1">
                {title}
            </p>
        </div>
    );
};